export enum DeviceType {
  MOBILE = "MOBILE",
  DESKTOP = "DESKTOP",
  TERMINAL = "TERMINAL",
  UNKNOWN = "UNKNOWN"
}

export interface DeviceInfo {
  deviceType: DeviceType;
  vendor?: string;
  model?: string;
  os?: string;
  osVersion?: string;
  browser?: string;
  browserVersion?: string;
}